export default __webpack_public_path__ + "static/media/Aeros App.31d6cfe0.title";